<!-- eslint-disable prettier/prettier -->
<template>
  <div>
    <div v-if="ocultarFormMovOperadores">
      <div class="col-md-10">
        <b-alert variant="success" show>
          <b class="font-weight-bold">Atenção:</b> Para garantir a segurança no sistema SPC Brasil, informamos que cada
          CPF pode ter apenas um operador cadastrado.
        </b-alert>
      </div>


      <div class="col-md-10">
        <b-breadcrumb class="font-weight-bold" style="color: white; background-color: #05428E; font-size: 14px;">
          Dados do operador:
        </b-breadcrumb>
      </div>



      <div class="col-md-10">
        <div class="form_padrao pt-2">
          <div class="form-row">

            <div class="form-group flutuante col-md-6">

              <div class="label">* Operação</div>
              <b-form-select name="mvTipo" id="mvTipo" v-model="operador.mvTipo" @change="mvTipoValidate"
                placeholder="Selecione">
                <option value="Inclusao">Incluir</option>
                <option value="Alteracao">Alterar</option>
                <option value="Exclusao">Excluir</option>
              </b-form-select>
              <p v-if="containsMvTipoValidate" style="font-size: 80%; color:#dc3545;">Selecione ao menos 1 tipo de
                operação.
              </p>
            </div>


            <div class="flutuante col-md-6" v-if="operador.mvTipo != 'Inclusao'">
              <div class="label">* Código do Operador</div>
              <b-form-input :state="codigoOperadorValidate" name="codigoOperador" id="codigoOperador"
                v-model="operador.codigoOperador" />

              <b-form-invalid-feedback :state="codigoOperadorValidate">
                Código Operador não pode ser vazio!
              </b-form-invalid-feedback>
            </div>


            <div class="form-group flutuante col-md-6" v-if="operador.mvTipo == 'Inclusao'">
              <div class="label">* Permissão:</div>
              <MultiSelect v-model="operador.permissao" :options="tipos" optionLabel="nome" showOptions="true"
                name="permissao" id="permissao" placeholder="Selecione os tipos" :state="permissaoValidate" required />

              <b-form-invalid-feedback :state="permissaoValidate">
                Selecione ao menos 1 tipo de permissão.
              </b-form-invalid-feedback>
            </div>


            <div class="flutuante col-md-5">
              <div class="label">* Nome do Operador</div>
              <b-form-input class="label" name="nomeOperador" id="nomeOperador" :value="operador.nome"
                v-model="operador.nomeOperador" :state="nomeOperadorValidate" @input="updateNome"
                placeholder="Informar o nome do usuário do operador" />
              <b-form-invalid-feedback :state="nomeOperadorValidate">
                Nome do usuário operador não pode ser vazio!
              </b-form-invalid-feedback>
            </div>

            <div class="flutuante col-md-1">
              <span class="badge badge-alert" style="color: #02C5B5; background: #f4f2f7" v-tooltip:top="'O Nome do Operador pode ser alterado como desejado'
                "><i class="material-icons">info</i></span>
            </div>










            <div class="flutuante col-md-5" v-if="operador.mvTipo === 'Inclusao'">
              <div class="label">Acesso de consulta personalizada</div>

              <b-form-input required type="text" name="consultaCustomizada" id="consultaCustomizada" ref="customizada"
                v-model="operador.consultaCustomizada" />
            </div>

            <div class="flutuante col-md-1" v-if="operador.mvTipo === 'Inclusao'">
              <span class="badge badge-alert" style="color: #02C5B5; background: #f4f2f7" v-tooltip:top="'Este campo permite restringir as consultas que deverão constar para o operador.'
                "><i class="material-icons">info</i></span>
            </div>

            <div class="form-group flutuante col-md-6" v-if="operador.mvTipo === 'Inclusao'">

              <div class="label">* Tipo de acesso:</div>
              <MultiSelect :state="meiosAcessoValidate" name="mvTipo" id="mvTipo" v-model="operador.meiosAcesso"
                :options="meios" optionLabel="nome" placeholder="Selecione os Meios de acesso" />

              <b-form-invalid-feedback :state="meiosAcessoValidate">
                Tipo de acesso não pode ser vazio!
              </b-form-invalid-feedback>
            </div>



          </div>



          <div class="form-row">

            <div class="col-md-12">
              <div class="form-group flutuante col-md-12" v-if="operador.mvTipo === 'Alteracao'">


                <textarea name="descricaoAlteracao" id="descricaoAlteracao" v-model="operador.descricaoAlteracao"
                  maxlength="1000" cols="10" rows="10" placeholder="* Descreva sua Solicitação."
                  :state="descricaoAlteracaoValidate" />
                <b-form-invalid-feedback :state="descricaoAlteracaoValidate">
                  A descrição não pode ser vazio!
                </b-form-invalid-feedback>
              </div>
            </div>

          </div>



        </div>
      </div>


      <p class="mb-4"></p>
      <p class="mb-4"></p>

      <div class="col-md-10">
        <b-breadcrumb v-if="operador.mvTipo === 'Inclusao'" class="font-weight-bold"
          style="color: white; background-color: #05428E; font-size: 14px;">
          Dados pessoa física:
        </b-breadcrumb>
      </div>

      <div class="col-md-10">
        <div class="form_padrao pt-2" v-if="operador.mvTipo === 'Inclusao'">
          <div class="form-row">

            <div class="flutuante col-md-6">
              <div class="label">* Nome</div>
              <b-form-input v-model="operador.nome" :state="nomeValidation" id="feedback-user" />
              <b-form-invalid-feedback :state="nomeValidation">
                Informar o Nome Completo
              </b-form-invalid-feedback>
            </div>


            <div class="flutuante col-md-6">
              <div class="label">* CPF</div>
              <b-form-input type="text" name="cpf" id="cpf" v-model="operador.cpf" required v-mask="'###.###.###-##'"
                @keyup="validarCpf(operador.cpf)" :state="errorCPF" />
              <div class="form-group">
                <b-form-invalid-feedback :state="errorCPF">
                  CPF inválido"
                </b-form-invalid-feedback>
              </div>
            </div>

            <div class="flutuante col-md-6">
              <div class="label">* Data de Nascimento</div>
              <b-form-input class="label" name="dataNascimento" id="dataNascimento" v-model="operador.dataNascimento"
                v-mask="'##/##/####'" :state="dataNascimentoValidation" placeholder="dd/mm/YYYY" />

              <b-form-invalid-feedback :state="dataNascimentoValidation">
                Data Nascimento inválida
              </b-form-invalid-feedback>

            </div>



            <div class="flutuante col-md-6">
              <div class="label">* E-mail</div>
              <b-form-input placeholder="Informar o e-mail do usuário do operador" type="email" name="emailOperador"
                id="emailOperador" v-model="operador.emailOperador" :state="validarEmail" />
              <b-form-invalid-feedback :state="validarEmail">
                E-mail inválido.
              </b-form-invalid-feedback>
            </div>



            <div class="flutuante col-md-6">
              <div class="label">Telefone</div>
              <b-form-input name="telefoneContato" id="telefoneContato" v-model="operador.telefoneContato"
                v-mask="['(##) ####-####', '(##) #####-####']" :state="validarTelefone" />
              <b-form-invalid-feedback :state="validarTelefone">
                Telefone não pode ser vazio!
              </b-form-invalid-feedback>
            </div>

            <div class="flutuante col-md-6">
              <div class="label">Celular</div>
              <b-form-input name="celularContato" id="celularContato" v-model="operador.celularContato"
                v-mask="['(##) ####-####', '(##) #####-####']" :state="validarCelular" />
              <b-form-invalid-feedback :state="validarCelular">
                Celular não pode ser vazio!
              </b-form-invalid-feedback>
            </div>


          </div>

          <p class="mb-4"></p>

        </div>
      </div>

      <p class="mb-4"></p>
      <p class="mb-4"></p>

      <div class="col-md-10">

        <b-breadcrumb v-if="operador.mvTipo === 'Inclusao'" class="font-weight-bold"
          style="color: white; background-color: #05428E; font-size: 14px;">
          Dias e horários permitidos para acesso:
        </b-breadcrumb>


        <div class="form-row" v-if="operador.mvTipo === 'Inclusao'">
          <div class="col-md-2">
            <div class="form-check mt-3 py-1 px-1">
              <input type="checkbox" id="domingo" value="domingo" v-model="checkedNameDomingo">
              <label for="domingo">Domingo</label>
            </div>
          </div>
          <div class="col-md-1 ">de</div>
          <div class="col-md-3"><input v-model="checkedDeDomingo" placeholder="00:00" :disabled="!checkedNameDomingo"
              type="text" v-mask="'##:##'"></div>
          <div class="col-md-1 ">às</div>
          <div class="col-md-3"><input v-model="checkedAsDomingo" placeholder="00:00" :disabled="!checkedNameDomingo"
              type="text" v-mask="'##:##'"></div>
        </div>

        <div class="form-row" v-if="operador.mvTipo === 'Inclusao'">
          <div class="col-md-2">
            <div class="form-check mt-3 py-1 px-1">
              <input type="checkbox" id="segunda" value="segunda" v-model="checkedNameSegunda">
              <label for="segunda">Segunda-feira</label>
            </div>
          </div>
          <div class="col-md-1 ">de</div>
          <div class="col-md-3"><input v-model="checkedDeSegunda" placeholder="00:00" :disabled="!checkedNameSegunda"
              type="text" v-mask="'##:##'"></div>
          <div class="col-md-1 ">às</div>
          <div class="col-md-3"><input v-model="checkedAsSegunda" placeholder="00:00" :disabled="!checkedNameSegunda"
              type="text" v-mask="'##:##'"></div>
        </div>

        <div class="form-row" v-if="operador.mvTipo === 'Inclusao'">
          <div class="col-md-2">
            <div class="form-check mt-3 py-1 px-1">
              <input type="checkbox" id="terca" value="terca" v-model="checkedNameTerca">
              <label for="terca">Terça-feira</label>
            </div>
          </div>
          <div class="col-md-1 ">de</div>
          <div class="col-md-3"><input v-model="checkedDeTerca" placeholder="00:00" :disabled="!checkedNameTerca"
              type="text" v-mask="'##:##'"></div>

          <div class="col-md-1 ">às</div>
          <div class="col-md-3"><input v-model="checkedAsTerca" placeholder="00:00" :disabled="!checkedNameTerca"
              type="text" v-mask="'##:##'"></div>
        </div>

        <div class="form-row" v-if="operador.mvTipo === 'Inclusao'">
          <div class="col-md-2">
            <div class="form-check mt-3 py-1 px-1">
              <input type="checkbox" id="quarta" value="quarta" v-model="checkedNameQuarta">
              <label for="quarta">Quarta-feira</label>
            </div>
          </div>
          <div class="col-md-1 ">de</div>
          <div class="col-md-3"><input v-model="checkedDeQuarta" placeholder="00:00" :disabled="!checkedNameQuarta"
              type="text" v-mask="'##:##'"></div>
          <div class="col-md-1 ">às</div>
          <div class="col-md-3"><input v-model="checkedAsQuarta" placeholder="00:00" :disabled="!checkedNameQuarta"
              type="text" v-mask="'##:##'"></div>

        </div>


        <div class="form-row" v-if="operador.mvTipo === 'Inclusao'">
          <div class="col-md-2">
            <div class="form-check mt-3 py-1 px-1">
              <input type="checkbox" id="quinta" value="quinta" v-model="checkedNameQuinta">
              <label for="quinta">Quinta-feira</label>
            </div>
          </div>
          <div class="col-md-1 ">de</div>
          <div class="col-md-3"><input v-model="checkedDeQuinta" placeholder="00:00" :disabled="!checkedNameQuinta"
              type="text" v-mask="'##:##'"></div>
          <div class="col-md-1 ">às</div>
          <div class="col-md-3"><input v-model="checkedAsQuinta" placeholder="00:00" :disabled="!checkedNameQuinta"
              type="text" v-mask="'##:##'"></div>
        </div>


        <div class="form-row" v-if="operador.mvTipo === 'Inclusao'">
          <div class="col-md-2">
            <div class="form-check mt-3 py-1 px-1">
              <input type="checkbox" id="sexta" value="sexta" v-model="checkedNameSexta">
              <label for="sexta">Sexta-feira</label>
            </div>
          </div>
          <div class="col-md-1 ">de</div>
          <div class="col-md-3"><input v-model="checkedDeSexta" placeholder="00:00" :disabled="!checkedNameSexta"
              type="text" v-mask="'##:##'"></div>
          <div class="col-md-1 ">às</div>
          <div class="col-md-3"><input v-model="checkedAsSexta" placeholder="00:00" :disabled="!checkedNameSexta"
              type="text" v-mask="'##:##'"></div>
        </div>




        <div class="form-row" v-if="operador.mvTipo === 'Inclusao'">
          <div class="col-md-2">
            <div class="form-check mt-3 py-1 px-1">
              <input type="checkbox" id="sabado" value="sabado" v-model="checkedNameSabado">
              <label for="sabado">Sábado</label>
            </div>
          </div>
          <div class="col-md-1 ">de</div>
          <div class="col-md-3"><input v-model="checkedDeSabado" placeholder="00:00" :disabled="!checkedNameSabado"
              type="text" v-mask="'##:##'"></div>
          <div class="col-md-1 ">às</div>
          <div class="col-md-3"><input v-model="checkedAsSabado" placeholder="00:00" :disabled="!checkedNameSabado"
              type="text" v-mask="'##:##'"></div>
          <div class="col-md-3"></div>
        </div>

        <div class="form-group" v-if="operador.mvTipo === 'Inclusao'">
          <div class="alert alert-danger border-0 text-center" v-if="error" role="alert">
            {{
              errorMsg
            }}
          </div>
        </div>

        <div class="col-12">
          <p class="mb-4"></p>
          <p class="mb-4"></p>

        </div>

        <hr class="simple" />

        <div class="form_padrao pt-2">
          <!-- Outros campos do formulário aqui -->

          <div class="form-row justify-content-end align-items-end">
            <!-- Outros campos do formulário aqui -->

            <div class="form-group flutuante col-md-3">
              <button type="button" class="btn btn-verde p-0 fit-content" @click="abrirChamado" v-if="!loading">
                <span>Solicitar</span>
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>


    <div class="loading-container" v-if="loading">
      <loading />
    </div>

  </div>
</template>

<script>
/* eslint-disable prettier/prettier */
import MultiSelect from "primevue/multiselect";
import { clearStr, validateCPF, validateEmail } from "../../helpers";
// import { Alert } from "bootstrap";

//import MultiSelect from 'vue-multiselect'


export default {
  name: "OperadoresSPC",
  components: {
    MultiSelect
  },
  data() {
    return {
      dataObj: new Date(),
      error: false,
      errorMsg: "",

      containsMvTipoValidate: true,

      ocultarFormMovOperadores: true,

      value: [
        { name: 'Javascript', code: 'js' }
      ],
      labelPosition: 'on-border',
      errorCPF: false,
      name: '',
      selectedTime: null,


      diasHorariosAcesso: [],
      checkedNames: [],

      checkedDeDomingo: '',
      checkedAsDomingo: '',
      checkedNameDomingo: false,

      checkedDeSegunda: '',
      checkedAsSegunda: '',
      checkedNameSegunda: false,


      checkedDeTerca: '',
      checkedAsTerca: '',
      checkedNameTerca: false,


      checkedDeQuarta: '',
      checkedAsQuarta: '',
      checkedNameQuarta: false,

      checkedDeQuinta: '',
      checkedAsQuinta: '',
      checkedNameQuinta: false,

      checkedDeSexta: '',
      checkedAsSexta: '',
      checkedNameSexta: false,

      checkedDeSabado: '',
      checkedAsSabado: '',
      checkedNameSabado: false,

      tipos: [
        { nome: "Consultar" },
        { nome: "Registrar" },
        { nome: "Relatório" },
      ],
      meios: [
        { nome: "Internet" },
        { nome: "Web Service (provedor)" },
        { nome: "Host a Host / VT100 (provedor)" },
        { nome: "Microterminal TCC (Garantia de Cheque)" },
      ],
      // produto: {
      //   nome: "SPC - Movimentação de Operadores",
      //   id: "SPC Operador",
      // },
      loading: false,
      operador: {
        cgc: "",
        nome: "",
        nomeOperador: "",
        emailOperador: "",
        cpf: "",
        dataNascimento: "",
        mvTipo: "",
        codigoOperador: "",
        cidade: "",
        diasHorarios: "",
        tipo: "",
        consultaCustomizada: "",
        telefoneContato: "",
        celularContato: "",
        meiosAcesso: [],
        descricaoAlteracao: "",
        permissao: []
      },
      breadcrumb: [
        {
          nome: "SPC - Movimentação de Operadores",
          id: "SPC Operador",
        },
      ],
    };
  },
  computed: {


    permissaoValidate() {

      if (this.operador.permissao.length === 0) {
        return false;
      }
      return true;
    },

    codigoOperadorValidate() {
      // ADICIONE ESTA VERIFICAÇÃO
      // Se 'codigoOperador' for undefined, null, etc., já retorna inválido.
      if (!this.operador || typeof this.operador.codigoOperador === 'undefined') {
        return false;
      }

      // AGORA O RESTO DO SEU CÓDIGO FICA SEGURO
      if (this.operador.codigoOperador.length === 0 || this.operador.codigoOperador === false) {
        return false;
      }
      return true;
    },

    meiosAcessoValidate() {
      if (this.operador.meiosAcesso.length === 0) {
        return false;
      }
      return true;
    },

    validarEmail() {

      if (validateEmail(this.operador.emailOperador) === true) {
        return true;
      }
      return false;
    },

    validarTelefone() {
      if (this.operador.telefoneContato.length >= 14) {
        return true;
      }
      return false;
    },

    validarCelular() {
      if (this.operador.celularContato.length >= 15) {
        return true;
      }
      return false;
    },

    dataNascimentoValidation() {

      if (this.operador.dataNascimento.length === 10) {
        const parts = this.operador.dataNascimento.split('/');
        const dia = parseInt(parts[0]);
        const mes = parseInt(parts[1]);
        const ano = parseInt(parts[2]);

        if (
          dia >= 1 && dia <= 31 &&
          mes >= 1 && mes <= 12 &&
          ano >= 1 && ano <= new Date().getFullYear()
        ) {
          const dataNascimento = new Date(parts.reverse().join('/'));
          const dataAtual = new Date();

          if (dataNascimento > dataAtual) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      }

      return false;

    },

    nomeValidation() {
      // this.operador.nomeOperador = this.operador.nome;
      if (this.operador.nome.length >= 3) {

        return true;
      }
      return false;
    },

    nomeOperadorValidate() {
      if (this.operador.nomeOperador.length >= 3) {
        return true;
      }
      return false;
    },
    descricaoAlteracaoValidate() {
      if (this.operador.descricaoAlteracao.length >= 5) {
        return true;
      }
      return false;
    },

    disabled() {
      return this.state === 'disabled'
    },

  },
  methods: {

    limparFormulario() {
      this.operador = {
        cgc: "",
        nome: "",
        nomeOperador: "",
        emailOperador: "",
        cpf: "",
        dataNascimento: "",
        mvTipo: "",
        codigoOperador: "",
        cidade: "",
        diasHorarios: "",
        tipo: "",
        consultaCustomizada: "",
        telefoneContato: "",
        celularContato: "",
        meiosAcesso: [],
        descricaoAlteracao: "",
        permissao: []
      };

      // Limpar checkboxes de dias da semana e horários
      this.checkedNameDomingo = false;
      this.checkedDeDomingo = "";
      this.checkedAsDomingo = "";

      this.checkedNameSegunda = false;
      this.checkedDeSegunda = "";
      this.checkedAsSegunda = "";

      this.checkedNameTerca = false;
      this.checkedDeTerca = "";
      this.checkedAsTerca = "";

      this.checkedNameQuarta = false;
      this.checkedDeQuarta = "";
      this.checkedAsQuarta = "";

      this.checkedNameQuinta = false;
      this.checkedDeQuinta = "";
      this.checkedAsQuinta = "";

      this.checkedNameSexta = false;
      this.checkedDeSexta = "";
      this.checkedAsSexta = "";

      this.checkedNameSabado = false;
      this.checkedDeSabado = "";
      this.checkedAsSabado = "";
    },

    updateNome(value) {
      this.operador.nome = value;
      // this.operador.nome = value; // Isso fará com que os dois campos sejam iguais
    },

    mvTipoValidate() {

      if (this.operador.mvTipo.length === 0) {
        this.containsMvTipoValidate = true;
      } else {
        this.containsMvTipoValidate = false;
      }


      if (this.operador.mvTipo === 'Inclusao') {
        this.operador.codigoOperador = '';
      }


      if (this.operador.mvTipo === 'Exclusao') {
        this.operador.meiosAcesso = '';
        this.operador.consultaCustomizada = '';
        this.operador.codigoOperador = '';
      }

    },

    validarCpf(cpfStr) {

      var cpf = clearStr(cpfStr);
      const result = validateCPF(cpf);

      if (!result) {
        this.errorCPF = false;
      } else {
        this.operador.cgc = this.operador.cpf;
        this.errorCPF = true;
      }

    },
    abrirChamado() {
      // ================================================================
      // ETAPA 1: TRANSFORMAR OS DADOS DO FORMULÁRIO (A CORREÇÃO ESTÁ AQUI)
      // ================================================================

      // Criamos uma cópia dos dados para manipular com segurança
      const dadosOperador = { ...this.operador };

      // DESTAQUE: Converte 'permissao' de array para string. 
      // Se estiver vazio, vira "". Funciona para TODOS os casos (Inclusão, Alteração, etc.)
      if (Array.isArray(dadosOperador.permissao)) {
        dadosOperador.permissao = dadosOperador.permissao
          .map(item => item.nome) // Pega apenas a propriedade 'nome'
          .join(', ');          // Junta em uma string: "Consultar, Registrar"
      }

      // DESTAQUE: A mesma conversão para o 'meiosAcesso'.
      if (Array.isArray(dadosOperador.meiosAcesso)) {
        dadosOperador.meiosAcesso = dadosOperador.meiosAcesso
          .map(item => item.nome) // Pega apenas a propriedade 'nome'
          .join(', ');          // Junta em uma string: "Internet, Web Service"
      }

      // Monta a string de dias e horários de acesso
      let diasHorariosString = "";
      const diasDaSemana = [
        { checked: this.checkedNameDomingo, de: this.checkedDeDomingo, as: this.checkedAsDomingo, nome: "Domingo de" },
        { checked: this.checkedNameSegunda, de: this.checkedDeSegunda, as: this.checkedAsSegunda, nome: "Segunda Feira de" },
        { checked: this.checkedNameTerca, de: this.checkedDeTerca, as: this.checkedAsTerca, nome: "Terça Feira de" },
        { checked: this.checkedNameQuarta, de: this.checkedDeQuarta, as: this.checkedAsQuarta, nome: "Quarta Feira de" },
        { checked: this.checkedNameQuinta, de: this.checkedDeQuinta, as: this.checkedAsQuinta, nome: "Quinta Feira de" },
        { checked: this.checkedNameSexta, de: this.checkedDeSexta, as: this.checkedAsSexta, nome: "Sexta Feira de" },
        { checked: this.checkedNameSabado, de: this.checkedDeSabado, as: this.checkedAsSabado, nome: "Sábado de" },
      ];

      diasDaSemana.forEach(dia => {
        if (dia.checked && dia.de.length === 5 && dia.as.length === 5) {
          diasHorariosString += ` - ${dia.nome} ${dia.de} às ${dia.as}`;
        }
      });
      dadosOperador.diasHorarios = diasHorariosString.trim();


      // ================================================================
      // ETAPA 2: VALIDAR OS DADOS
      // ================================================================

      
      if (!dadosOperador.mvTipo) {
        this.$toast.open({ message: "O campo 'Operação' é obrigatório.", type: "error" });
        return;
      }

      if (dadosOperador.mvTipo === 'Inclusao') {
        if (!dadosOperador.nome || !dadosOperador.cpf || !dadosOperador.dataNascimento || !dadosOperador.emailOperador || !dadosOperador.permissao || !dadosOperador.meiosAcesso) {
          this.$toast.open({ message: "Preencha todos os campos obrigatórios (*).", type: "error" });
          return;
        }
        if (dadosOperador.diasHorarios.length === 0) {
          this.$toast.open({ message: "Selecione ao menos um dia e horário de acesso válido.", type: "error" });
          return;
        }
      } else if (dadosOperador.mvTipo === 'Alteracao') {
        if (!dadosOperador.codigoOperador || dadosOperador.descricaoAlteracao.length < 5) {
          this.$toast.open({ message: "Para alterar, o código do operador e uma descrição de no mínimo 5 caracteres são obrigatórios.", type: "error" });
          return;
        }
      } else if (dadosOperador.mvTipo === 'Exclusao') {
        if (!dadosOperador.codigoOperador) {
          this.$toast.open({ message: "Para excluir, o código do operador é obrigatório.", type: "error" });
          return;
        }
      }

      // ================================================================
      // ETAPA 3: MONTAR E ENVIAR O PACOTE DE DADOS PARA A API
      // ================================================================

      this.loading = true;


      const contatoEmail =
      this.$user?.dadosCadastraisAssociado?.[0]?.email ||
      (this.operador.emailOperador || '').trim()

      const contatoNome =
        this.$user?.dadosCadastraisAssociado?.[0]?.contato ||
        this.operador.nomeOperador ||
        this.operador.nome || ''

      const contatoTelefone =
        this.$user?.dadosCadastraisAssociado?.[0]?.telefone ||
        this.operador.celularContato ||
        this.operador.telefoneContato ||
        '';

      const dataset = {
        CodigoOperador: dadosOperador.codigoOperador,
        ConsultaCustomizada: dadosOperador.consultaCustomizada,
        Cpf: dadosOperador.cpf,
        DataNascimento: dadosOperador.dataNascimento,
        DiasHorarios: dadosOperador.diasHorarios,

        // 👇 mantém o que você já mandava
        MeiosAcesso: dadosOperador.meiosAcesso,
        MvTipo: dadosOperador.mvTipo,
        Nome: dadosOperador.nome,
        NomeOperador: dadosOperador.nomeOperador,
        TelefoneContato: dadosOperador.telefoneContato,
        CelularContato: dadosOperador.celularContato,
        Tipo: dadosOperador.permissao,
        DescricaoAlteracao: dadosOperador.descricaoAlteracao,

        // 👇 **conserta o problema do "Email do Operador"** (backend pode ser case-sensitive)
        EmailOperador: (this.operador.emailOperador || '').trim(), // PascalCase
        emailOperador: (this.operador.emailOperador || '').trim(), // camelCase (compat)

        NomeContato: contatoNome,
        Telefone: contatoTelefone,
        Email: contatoEmail,        // <— A API exige isso pro “Nome/Telefone/E-mail”
        EmailContato: contatoEmail  // alias comum aceito por muitos backends
      };



      this.$http
        .post("/api/CdlBh/RegistrarChamadoOperadoresSPC", dataset)
        .then((response) => {
          this.loading = false;
          const chamado = response.data.mensagem;

          this.$bvToast.toast(`Chamado ${chamado} aberto com sucesso!`, {
            title: '✅ CHAMADO ABERTO!',
            variant: 'success',
            solid: true,
            toaster: "b-toaster-top-center",
            noAutoHide: true,
            appendToast: true,
          });

          this.limparFormulario();
        })
        .catch((error) => {
          this.loading = false;
          console.error('DETALHES COMPLETOS DO ERRO:', error.response);

          // Tenta pegar a mensagem de erro específica da API, senão mostra uma genérica
          const errorMsg = error.response?.data?.errors
            ? Object.values(error.response.data.errors).flat().join(' ')
            : error.response?.data?.mensagem || "Ocorreu um erro inesperado.";

          this.$toast.open({ message: errorMsg, type: "error", duration: 20000 });
        });
    },

  },
  watch: {

    checkedNameDomingo(newValue) {
      if (!newValue) {

        this.checkedDeDomingo = '';
        this.checkedAsDomingo = '';
        this.diasHorariosAcesso[0] = "";
      }
    },

    checkedNameSegunda(newValue) {
      if (!newValue) {

        this.checkedDeSegunda = '';
        this.checkedAsSegunda = '';
        this.diasHorariosAcesso[1] = "";
      }
    },

    checkedNameTerca(newValue) {
      if (!newValue) {
        this.checkedDeTerca = '';
        this.checkedAsTerca = '';
        this.diasHorariosAcesso[2] = "";
      }
    },

    checkedNameQuarta(newValue) {
      if (!newValue) {
        this.checkedDeQuarta = '';
        this.checkedAsQuarta = '';
        this.diasHorariosAcesso[3] = "";
      }
    },

    checkedNameQuinta(newValue) {
      if (!newValue) {
        this.checkedDeQuinta = '';
        this.checkedAsQuinta = '';
        this.diasHorariosAcesso[4] = "";
      }
    },

    checkedNameSexta(newValue) {
      if (!newValue) {
        this.checkedDeSexta = '';
        this.checkedAsSexta = '';
        this.diasHorariosAcesso[5] = "";
      }
    },

    checkedNameSabado(newValue) {
      if (!newValue) {
        this.checkedDeSabado = '';
        this.checkedAsSabado = '';
        this.diasHorariosAcesso[6] = "";
      }
    }

  },
  created() {
    // this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
  },
};
</script>

<style lang="scss" scoped>
.loading-container {
  display: flex;
  justify-content: center;
  /* Centraliza horizontalmente */
  align-items: center;
  /* Centraliza verticalmente */
  height: 100vh;
  /* Ocupa a altura total da tela */
  width: 100%;
  /* Ocupa a largura total */
  position: fixed;
  /* Fixa na tela */
  top: 0;
  left: 0;
  /* background: rgba(255, 255, 255, 0.8); */
  /* Fundo branco semi-transparente */
  z-index: 9999;
  /* Garante que fica acima de outros elementos */
}

textarea {
  overflow: auto;
  resize: none;
  width: 639px;
  font-size: 14px;
  margin-bottom: 5px;
  margin-top: 18px;
  line-height: 1.4;
  padding: 0 25px;
  color: #212529;
  padding-top: 21px;
  border-color: #dee2e6;

}

.label {
  font-size: 14px;
  margin-bottom: 5px;
  line-height: 1.4;
}

.col-md-1 {
  display: flex;
  /* Tornar o conteúdo flexível */
  align-items: center;
  /* Centralizar verticalmente */
  justify-content: center;
  /* Centralizar horizontalmente */
}

.col-md-3 {
  display: flex;
  /* Tornar o conteúdo flexível */
  align-items: center;
  /* Centralizar verticalmente */
  justify-content: center;
  /* Centralizar horizontalmente */
}

.form_padrao .form-check label {
  color: #212529;
}

.form_padrao .form-group.flutuante input[type=text] {
  background: #ffffff;
}


.form_padrao .form-group.flutuante input[type=email] {
  background: #ffffff;
}



.checkbox-container {
  display: block;
  /* Altera a exibição para bloco */
  margin-bottom: 10px;
  /* Adiciona um espaço entre os checkboxes */
}

.breadcrumb-item {
  color: #f12;
}

hr {
  color: #888 !important;
  border-color: rgb(206, 206, 206) !important;
}

.p-datepicker-title select {
  color: black;
  font-size: 0.8rem;
  width: auto !important;
}

.p-datepicker-title {
  display: flex !important;
}

.listBox {
  border: 0px !important;

  div {
    ul {
      background: #e5e6f1 !important;
    }
  }
}

.notification {
  width: 100%;
  bottom: -9px;
  left: 9px;
  font-size: 10px;
}

.p-multiselect {
  width: 100%;
  background: rgb(255, 255, 255);
  border: 0;
  outline: none !important;
  height: 38px;
  padding: 10px 25px 0;
  color: #1e5599;
  transition: all 0.25s ease;
}

.p-multiselect .p-multiselect-trigger {
  background: #FFFFFF;
}

.form_padrao select {
  height: 38px;
  border: 1px;
  border-color: #000000;
  line-height: 1.5;
  background-color: #ffffff;
}

.p-multiselect .p-multiselect-label.p-placeholder {
  padding: .375rem .75rem;
}
</style>